<template>
    <div v-if="$route.params.item" class="host page" style="margin-left:25px; display:flex; flex-direction:column">
        <form @submit.prevent="submitCard">
         <div style="display:flex; justify-content:space-between">
            <div style="display:flex; flex-direction:column; justify-content:center">
                <h2 style="align-self:center; display:flex">
                    Медицинская карта № <input v-model="commonData.cardid" disabled class="form-control" style="width:200px" />
                </h2>
                <h3>
                    Персональные данные пациента
                </h3>
            </div>
            <div style="border: 5px solid lightgray">
                <img v-if="$route.params.item.avatar" :src="$route.params.item.avatar" style="width:100px" />
                <svg
                    v-else
                    class="bi bi-camera"
                    style="margin:25px"
                    width="4em"
                    height="3em"
                    viewBox="0 0 16 16"
                    fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path d="M9 5C7.343 5 5 6.343 5 8a4 4 0 0 1 4-4v1z" />
                    <path
                    fill-rule="evenodd"
                    d="M14.333 3h-2.015A5.97 5.97 0 0 0 9 2a5.972 5.972 0 0 0-3.318 1H1.667C.747 3 0 3.746 0 4.667v6.666C0 12.253.746 13 1.667 13h4.015c.95.632 2.091 1 3.318 1a5.973 5.973 0 0 0 3.318-1h2.015c.92 0 1.667-.746 1.667-1.667V4.667C16 3.747 15.254 3 14.333 3zM1.5 5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1zM9 13A5 5 0 1 0 9 3a5 5 0 0 0 0 10z"
                    />
                    <path d="M2 3a1 1 0 0 1 1-1h1a1 1 0 0 1 0 2H3a1 1 0 0 1-1-1z" />
                </svg>
            </div>
         </div>
        <b-list-group style="border-radius:15px">
            <b-list-group-item>
                <div class="rowData">
                    <div class="rowField">
                        <span class="nameField" style="width: 260px">1. Дата заполнения: </span> 
                        <input class="form-control" v-model="item['Дата заполнения медицинской карты']" type="date"/>
                    </div>
                </div>
            </b-list-group-item>
            <b-list-group-item>
               <div class="rowData">
                   <div class="rowField"><span class="nameField">2. Фамилия:</span> <input required class="form-control inputData" v-model="commonData['Фамилия']"/></div>
                   <div class="rowField"><span class="nameField"> Имя: </span><input required class="form-control inputData" v-model="commonData['Имя']"/></div> 
                   <div class="rowField"><span class="nameField"> Отчество: </span><input required class="form-control inputData" v-model="commonData['Отчество']"/></div>
                </div>
            </b-list-group-item>
            <b-list-group-item>
               <div class="rowData">
                   <div class="rowField"><span class="nameField">3. Пол: </span> 
                        <b-form-select class="form-control inputData" v-model="commonData['Пол']">
                       <b-form-select-option :value="''">не указан</b-form-select-option>
                       <b-form-select-option :value="'мужской'">мужской</b-form-select-option>
                       <b-form-select-option :value="'женский'">женский</b-form-select-option>
                       </b-form-select>
                    </div>
               </div>
            </b-list-group-item>
            <b-list-group-item>
                <div class="rowData">
                    <div class="rowField">
                        <span class="nameField" style="width:250px">4. Дата рождения: </span>
                        <input class="form-control" v-model="commonData['Дата рождения']" type="date" required/>
                    </div>
                </div>
            </b-list-group-item>
            <b-list-group-item>
                <div class="rowData">
                    <div class="rowField">
                        <span class="nameField" >5. Место регистрации: </span>
                        <span class="nameField">субъект РФ</span>
                        <v-select style="width:250px; background:white; margin-bottom:0"
                            :options="subjects" :value="item['Место регистрации']['субъект Российской Федерации']"
                            v-model="selected.subject" label="offname"
                            @keyup.native="getAddress($event.target.value, 1)"
                            @input="chooseAddr($event, 'субъект Российской Федерации', 1)"
                            @search:focus="getAddress('', 1)"
                            >
                            <template v-slot:no-options="{ search, searching }">
                                <template v-if="searching">
                                    Не найдено: <em>{{ search }}</em>.
                                </template>
                                <em style="opacity: 0.5;" v-else>Начните набирать...</em>
                            </template>
                            <template slot="option" slot-scope="option" :value="option.aoguid">
                                <div> {{option.offname}}</div>
                            </template>
                        </v-select>
                    </div>
                </div>
                <div class="rowData" style="flex-direction: column">
                    <div class="rowField" style="margin:10px">
                        <span class="nameField" >район: </span>
                        <v-select style="width:250px; background:white; margin-bottom:0; margin-right:10px"
                                :disabled="!item['Место регистрации']['субъект Российской Федерации']"
                                :options="subjects"
                                v-model="selected.region" :appendToBody="true"
                                label="offname" :value="item['Место регистрации']['район']"
                                @keyup.native="getAddress($event.target.value, 3)"
                                @input="chooseAddr($event, 'район', 3)"
                                @search:focus="getAddress('', 3)"
                                >
                                <template v-slot:no-options="{ search, searching }">
                                    <template v-if="searching">
                                        Не найдено: <em>{{ search }}</em>.
                                    </template>
                                    <em style="opacity: 0.5;" v-else>Начните набирать...</em>
                                </template>
                                <template slot="option" slot-scope="option">
                                    <div> {{option.shortname}} {{option.offname}}</div>
                                </template>
                        </v-select>
                        <span class="nameField" >город: </span>
                        <v-select style="width:200px; background:white; margin-bottom:0; margin-right:10px"
                                :disabled="!item['Место регистрации']['субъект Российской Федерации']"
                                :options="subjects"
                                v-model="selected.city" :appendToBody="true"
                                label="offname"
                                :value="item['Место регистрации']['город']"
                                @keyup.native="getAddress($event.target.value, 4)"
                                @input="chooseAddr($event, 'город', 4)"
                                @search:focus="getAddress('', 4)"
                                >
                                <template v-slot:no-options="{ search, searching }">
                                    <template v-if="searching">
                                        Не найдено: <em>{{ search }}</em>.
                                    </template>
                                    <em style="opacity: 0.5;" v-else>Начните набирать...</em>
                                </template>
                                <template slot="option" slot-scope="option">
                                    <div> {{option.shortname}} {{option.offname}}</div>
                                </template>
                        </v-select>
                        <span class="nameField" >населенный пункт: </span>
                        <v-select style="width:250px; background:white; margin-bottom:0"
                                :options="subjects"
                                v-model="selected.point" :appendToBody="true"
                                label="offname"
                                :value="item['Место регистрации']['населенный пункт']"
                                @keyup.native="getAddress($event.target.value, 6)"
                                @input="chooseAddr($event, 'населенный пункт', 6)"
                                @search:focus="getAddress('', 6)"
                                >
                                <template v-slot:no-options="{ search, searching }">
                                    <template v-if="searching">
                                        Не найдено: <em>{{ search }}</em>.
                                    </template>
                                    <em style="opacity: 0.5;" v-else>Начните набирать...</em>
                                </template>
                                <template slot="option" slot-scope="option">
                                    <div> {{option.shortname}} {{option.offname}}</div>
                                </template>
                        </v-select>
                    </div>
                    
                    <div class="rowField" style="margin: 10px">
                        <span class="nameField" >улица: </span>
                        <v-select style="width:250px; background:white; margin-bottom:0; margin-right:10px"
                                :disabled="!selected.city && !selected.point"
                                :options="subjects"
                                v-model="selected.street" :appendToBody="true"
                                label="offname"
                                :value="item['Место регистрации']['улица']"
                                @keyup.native="getAddress($event.target.value, 7)"
                                @input="chooseAddr($event, 'улица', 7)"
                                @search:focus="getAddress('', 7)"
                                >
                                <template v-slot:no-options="{ search, searching }">
                                    <template v-if="searching">
                                        Не найдено: <em>{{ search }}</em>.
                                    </template>
                                    <em style="opacity: 0.5;" v-else>Начните набирать...</em>
                                </template>
                                <template slot="option" slot-scope="option">
                                    <div> {{option.shortname}} {{option.offname}}</div>
                                </template>
                        </v-select>
                        <span class="nameField" >дом: </span>
                        <input :disabled="!item['Место регистрации']['улица']" class="form-control" style="width:100px; margin-right:10px" v-model="item['Место регистрации']['дом']" />
                        <span class="nameField" >квартира: </span>
                        <input :disabled="!item['Место регистрации']['дом']" class="form-control" style="width:100px; margin-right:10px" v-model="item['Место регистрации']['квартира']"/>
                        <span class="nameField" >телефон: </span>
                        <!--input type="tel" :disabled="!commonData.phone" class="form-control" 
                         pattern="[\+]\d{1}\s\d{3}\s\d{3}[\-]\d{2}[\-]\d{2}" 
                        style="width:200px; margin-right:10px" v-model="commonData.phone"/>
                        <span class="form__error">Это поле должно содержать телефон в формате +7 (123) 456-78-90</span-->
                        <telephoneInput v-model="commonData.phone" :current="commonData.phone" />
                    </div>
                </div>
            </b-list-group-item>
            <b-list-group-item>
               <div class="rowData">
                   <div class="rowField"><span class="nameField">6. Местность: </span> 
                   <b-form-select class="form-control inputData" v-model="item['Местность']">
                       <b-form-select-option :value="''">не указан</b-form-select-option>
                       <b-form-select-option :value="'Городская'">Городская</b-form-select-option>
                       <b-form-select-option :value="'Сельская'">Сельская</b-form-select-option>
                       </b-form-select>
                    </div>
               </div>
            </b-list-group-item>
            <b-list-group-item>
               <div class="rowData">
                   <div class="rowField"><span class="nameField">7. Полис ОМС: </span> <span class="nameField" style="font-weight:400; margin-left:20px">серия</span><input class="form-control inputData" v-model="item['Полис ОМС'].serial"/></div>
                   <div class="rowField"><span class="nameField" style="font-weight:400; margin-left:0px"> № </span><input class="form-control inputData" v-model="item['Полис ОМС'].number"/></div> 
                   <div class="rowField"><span class="nameField"> 8. СНИЛС: </span><input class="form-control inputData" v-model="item['СНИЛС']"/></div>
                </div>
            </b-list-group-item>
            <b-list-group-item>
                <div class="rowData" style="width:100%">
                    <div class="rowField" style="width:100%">
                        <span class="nameField" >9. Наименование страховой медицинской организации: </span>
                        <v-select style="width: 60%; background:white; margin-bottom:0"
                            :reduce="opt => opt.NAM_SMOK" :options="foms" value=""
                            v-model="item['Наименование страховой медицинской организации']" label="NAM_SMOK"
                            @keyup.native="getFoms($event.target.value)"
                            @search:focus="getFoms('')"
                            >
                            <template v-slot:no-options="{ search, searching }">
                                <template v-if="searching">
                                    Не найдено: <em>{{ search }}</em>.
                                </template>
                                <em style="opacity: 0.5;" v-else>Начните набирать...</em>
                            </template>
                        </v-select>
                    </div>
                </div>
            </b-list-group-item>
            <b-list-group-item>
                <div class="rowData" style="width:100%">
                    <div class="rowField" style="width:100%">
                        <span class="nameField" >10. Код категории льготы: </span>
                        <v-select style="width: 81%; background:white; margin-bottom:0"
                            :reduce="opt => opt.DESCR" :options="lgoti" value=""
                            v-model="item['Код категории льготы']" label="DESCR"
                            @keyup.native="getLgoti($event.target.value)"
                            @search:focus="getLgoti('')"
                            >
                            <template v-slot:no-options="{ search, searching }">
                                <template v-if="searching">
                                    Не найдено: <em>{{ search }}</em>.
                                </template>
                                <em style="opacity: 0.5;" v-else>Начните набирать...</em>
                            </template>
                        </v-select>
                    </div>
                </div>
            </b-list-group-item>
            <b-list-group-item>
               <div class="rowData" style="justify-content:flex-start">
                   <div class="rowField" style="margin-right:10px"><span class="nameField">11. Документ: </span><input class="form-control inputData" v-model="item['Документ'].type"/></div>
                   <div class="rowField" style="margin-right:10px"><span class="nameField" style="font-weight:400; margin-left:0px"> серия </span><input class="form-control inputData" v-model="item['Документ'].serial"/></div> 
                   <div class="rowField" style="margin-right:10px"><span class="nameField" style="font-weight:400; margin-left:0px"> № </span><input class="form-control inputData" v-model="item['Документ'].number"/></div>
                </div>
            </b-list-group-item>
            <b-list-group-item>
               <div class="rowData">
                   <div class="rowField"><span class="nameField">12. Семейное положение: </span> 
                        <b-form-select class="form-control inputData" style="width:350px" v-model="item['Семейное положение']">
                            <b-form-select-option :value="'Неизвестно'">Неизвестно</b-form-select-option>
                            <b-form-select-option :value="'Состоит в зарегистрированном браке'">Состоит в зарегистрированном браке</b-form-select-option>
                            <b-form-select-option :value="'Не состоит в браке'">Не состоит в браке</b-form-select-option>
                       </b-form-select>
                    </div>
               </div>
            </b-list-group-item>
            <b-list-group-item>
               <div class="rowData">
                   <div class="rowField"><span class="nameField">13. Образование: </span> 
                        <b-form-select :options="education" class="form-control inputData" style="width:350px" v-model="item['Образование']"></b-form-select>
                    </div>
               </div>
            </b-list-group-item>
            <b-list-group-item>
               <div class="rowData">
                   <div class="rowField" style="width:100%"><span class="nameField">14. Занятость: </span> 
                        <input class="form-control inputData" style="width:88%" v-model="item['Занятость']"/>
                    </div>
               </div>
            </b-list-group-item>
            <b-list-group-item>
               <div class="rowData">
                   <div class="rowField" style="width:100%"><span class="nameField">15. Инвалидность: </span> 
                        <input class="form-control inputData" style="width:85%" v-model="item['Инвалидность']"/>
                    </div>
               </div>
            </b-list-group-item>
            <b-list-group-item>
               <div class="rowData">
                   <div class="rowField" style="width:100%"><span class="nameField">16. Место работы, должность: </span> 
                        <input class="form-control inputData" style="width:77%" v-model="item['Место работы, должность']"/>
                    </div>
               </div>
            </b-list-group-item>
            <b-list-group-item>
               <div class="rowData">
                   <div class="rowField" style="width:100%"><span class="nameField">17. Изменение места работы: </span> 
                        <input class="form-control inputData" style="width:77%" v-model="item['Изменение места работы']"/>
                    </div>
               </div>
            </b-list-group-item>
            <b-list-group-item>
               <div class="rowData">
                   <div class="rowField" style="width:100%"><span class="nameField">18. Изменение места регистрации: </span> 
                        <input class="form-control inputData" style="width:73%" v-model="item['Изменение места регистрации']"/>
                    </div>
               </div>
            </b-list-group-item>
            <b-list-group-item>
               <div class="rowData">
                   <div class="rowField"><span class="nameField">19. Группа крови: </span> 
                        <b-form-select class="form-control inputData" v-model="item['Группа крови']">
                            <b-form-select-option :value="''">не указан</b-form-select-option>
                            <b-form-select-option :value="'0(I)'">0 (I)</b-form-select-option>
                            <b-form-select-option :value="'A(II)'">A (II)</b-form-select-option>
                            <b-form-select-option :value="'B(III)'">B (III)</b-form-select-option>
                            <b-form-select-option :value="'AB(IV)'">AB (IV)</b-form-select-option>

                       </b-form-select>
                    </div>
               </div>
            </b-list-group-item>
            <b-list-group-item>
               <div class="rowData">
                   <div class="rowField"><span class="nameField">20. Rh-фактор: </span> 
                        <b-form-select class="form-control inputData" v-model="item['Rh-фактор']">
                            <b-form-select-option :value="''">не указан</b-form-select-option>
                            <b-form-select-option :value="'+'">Положительный</b-form-select-option>
                            <b-form-select-option :value="'-'">Отрицательный</b-form-select-option>
                       </b-form-select>
                    </div>
               </div>
            </b-list-group-item>
            <b-list-group-item>
               <div class="rowData">
                   <div class="rowField" style="width:100%"><span class="nameField">21. Аллергические реакции: </span> 
                        <input class="form-control inputData" style="width:77%" v-model="item['Аллергические реакции']"/>
                    </div>
               </div>
            </b-list-group-item>
        </b-list-group>
        <div class="rowData" style="margin-top:10px">
            <vmbutton @click="$route.params.prev ? $router.push({name: $route.params.prev}) : $router.push({name: 'registry.patients'})">Назад</vmbutton>
            <div style="display:flex">
                <vmbutton @click="printCard()" style="margin-right:10px">Печать</vmbutton>
                <vmbutton type="submit">Сохранить</vmbutton>
            </div>
        </div>
    </form>
    </div>
</template>



<script>
import { patientApi, dictionaryFiasApi, dictionaryFomsApi, dictionaryLgotiApi, receptionApi } from '@app/services';
import { debounce } from 'lodash';
import vmbutton from '@app/components/uikit/VMButton';
import telephoneInput from '@app/components/uikit/telephoneInput';
import toastr from 'toastr';

export default {
    components: {vmbutton, telephoneInput},
    data() {
        return {
            item: this.$route.params.item && !_.isEmpty(this.$route.params.item.data) ? this.$route.params.item.data : {
                'Дата заполнения медицинской карты': moment(new Date()).format('YYYY-MM-DD'),
                'Место регистрации': {
                    'субъект Российской Федерации': '',
                    'район': '',
                    'город': '',
                    'населенный пункт': '',
                    'улица': '',
                    'дом': '',
                    'квартира': ''
                },
                'Местность': '',
                'Полис ОМС': {serial: '', number: ''},
                'СНИЛС': '',
                'Наименование страховой медицинской организации': '',
                'Код категории льготы': '',
                'Документ': {type: '', serial: '', number: ''},
                'Семейное положение': '',
                'Образование': '',
                'Занятость': '',
                'Инвалидность': '',
                'Место работы, должность': '',
                'Изменение места работы': '',
                'Изменение места регистрации': '',
                'Группа крови': '',
                'Rh-фактор': '',
                'Аллергические реакции': ''
            },
            commonData: {
                'Фамилия': this.$route.params.item && this.$route.params.item.lastName ? this.$route.params.item.lastName : '',
                'Имя': this.$route.params.item && this.$route.params.item.firstName ? this.$route.params.item.firstName : '',
                'Отчество': this.$route.params.item && this.$route.params.item.middleName ? this.$route.params.item.middleName : '',
                'Дата рождения': this.$route.params.item && this.$route.params.item.birthDay ? this.$route.params.item.birthDay : '',
                'Пол': this.$route.params.item && this.$route.params.item.gender ? this.$route.params.item.gender : '',
                cardid: this.$route.params.item && this.$route.params.item.cardid ? this.$route.params.item.cardid : '',
                phone: this.$route.params.item && this.$route.params.item.phone ? this.$route.params.item.phone : ''
            },
            subjects: [],
            cur_subject: '',
            prev_subject: '',
            selected: {
                subject: this.$route.params.item && !_.isEmpty(this.$route.params.item.data) ? { offname: this.$route.params.item.data['Место регистрации']['субъект Российской Федерации']} : '',
                region: this.$route.params.item && !_.isEmpty(this.$route.params.item.data) ? { offname: this.$route.params.item.data['Место регистрации']['район']} : '',
                city: this.$route.params.item && !_.isEmpty(this.$route.params.item.data) ? { offname: this.$route.params.item.data['Место регистрации']['город']} : '',
                point: this.$route.params.item && !_.isEmpty(this.$route.params.item.data) ? { offname: this.$route.params.item.data['Место регистрации']['населенный пункт']} : '',
                street: this.$route.params.item && !_.isEmpty(this.$route.params.item.data) ? { offname: this.$route.params.item.data['Место регистрации']['улица']} : ''
            },
            foms: [],
            education: [
                {
                    value: '', text: 'Неизвестно'
                },
                {
                    label: 'Профессиональное',
                    options: [
                        'Высшее',
                        'Среднее'
                    ]
                },
                {
                    label: 'Общее',
                    options: [
                        'Среднее',
                        'Основное',
                        'Начальное'
                    ]
                }
            ],
            lgoti: []
        };
    },
    mounted() { console.log(this.commonData);
        if (!this.$route.params.item) {
            this.$router.push({name: 'registry.patients'});
        }
    },
    methods: {
        getAddress: debounce(function (str, level) {
            let params = {level};
            let parentguid;
            if (this.cur_subject && level !== 1) {
                params.parentguid = this.cur_subject;
            }
              dictionaryFiasApi.getAll(undefined, undefined, str, undefined, params).then(res => {
                  this.subjects = res.items;
           });
        }, 500),

        getFoms: debounce(function (str) {
            dictionaryFomsApi.getAll(undefined, undefined, str).then(res => {
                  this.foms = res.items;
           });
        }, 500),

        getLgoti: debounce(function (str) {
            dictionaryLgotiApi.getAll(undefined, undefined, '').then(res => {
                  this.lgoti = res.items;
           });
        }, 500),

        submitCard() {
            if (this.$route.params.item.id) {
                const data = { 
                    first_name: this.commonData['Имя'],
                    last_name: this.commonData['Фамилия'],
                    middle_name: this.commonData['Отчество'],
                    gender: this.commonData['Пол'] === 'мужской' ? 'male' : this.commonData['Пол'] === 'женский' ? 'female' : this.commonData['Пол'],
                    cardid: this.commonData.cardid, 
                    date_of_birth: this.commonData['Дата рождения'],
                    phone: this.commonData.phone,
                    data: this.item
                    };
                patientApi.editPatient(this.$route.params.item.id, data).then(res => {
                    toastr.info('Запись сохранена успешно');
                }).catch(error => {
                    toastr.error(error);
                });
            } else {
               // const username = prompt('Введите электронную почту: ', '');
               // if(!this.validateEmail(username).isValid) {
               //     alert('Неправильно введен e-mail');
               // } else {
                    const data = { 
                        first_name: this.commonData['Имя'],
                        last_name: this.commonData['Фамилия'],
                        middle_name: this.commonData['Отчество'],
                        gender: this.commonData['Пол'] === 'мужской' ? 'male' : this.commonData['Пол'] === 'женский' ? 'female' : this.commonData['Пол'],
                        // cardid: this.commonData.cardid, 
                        date_of_birth: this.commonData['Дата рождения'] ? this.commonData['Дата рождения'] : null,
                        data: this.item,
                        phone: this.commonData.phone,
                        username: this.commonData.phone
                        };
                   patientApi.createPatient(data).then(res => {
                      toastr.info('Запись сохранена успешно');
                      this.commonData.cardid = res.cardid;
                   }).catch(error => { console.log(error);
                       toastr.error(error);
                   });
               // }
            }
        },
        validateEmail(data) {
            if( /(.+)@(.+){2,}\.(.+){2,}/.test(data) ){
            return {
                isValid: true,
                message: ''
            };
            } else {
            return {
                isValid: false,
                message: 'Email address is required'
            };
            }
        },
        chooseAddr(evt, prop, lvl) {
            if (evt) {
                this.cur_subject = evt.aoguid;
                this.prev_subject = evt.parentguid,
                this.item['Место регистрации'][prop] = evt.offname;
                this.subjects = [];
            } else {
                this.item['Место регистрации'][prop] = '';
                this.cur_subject = this.prev_subject;
                if (lvl === 3) {
                    this.cur_subject = this.selected.subject.aoguid;
                } else if (lvl === 4) {
                    this.cur_subject = this.selected.subject.aoguid;
                } else if (lvl === 6) {
                    this.cur_subject = this.selected.region.aoguid;
                } else if (lvl === 7) {
                    if (this.selected.city)  {
                        this.cur_subject = this.selected.city.aoguid;
                    } else if (this.selected.region) {
                        this.cur_subject = this.selected.point.aoguid;
                    }
                }
            }
        },
        printCard() {
            receptionApi.printCardPatient(this.$route.params.uuidPatient, this.$store.state.clinic.id).then(res => {
               if (res.result) {
                    window.open('https://view.officeapps.live.com/op/view.aspx?src=' + process.env.VUE_APP_API_URL + res.file, '_blank');
                } else {
                    toastr.error(res.msg);
                }
            }).catch(error => {
                toastr.error(error);
            });
        }
    }
    
};
</script>


<style lang="scss" scoped>
    .nameField {
        font-weight: 700;
        align-self: center;
        margin-right: 10px;
    }
    .inputData {
        width: 250px;
    }
    .rowData {
        display: flex;
        justify-content: space-between;
        width: 100%;
        flex-direction: row;
    }
    .rowField {
        display:flex;
    }
::v-deep .input-group {
        width:200px;
    }
</style>